import React from 'react';
import PropTypes from 'prop-types';

import { Scroller } from './Scroller';

export const WithScroller = ({ children, useScroller, ...rest }) => {
    const ChildComponent = () => children({ ...rest });
    return useScroller ? (
        <Scroller>
            <ChildComponent />
        </Scroller>
    ) : (
        <ChildComponent />
    );
};

WithScroller.propTypes = {
    useScroller: PropTypes.bool,
    children: PropTypes.node,
};
